import NavbarStaff from "./NavbarStaff";
import { Outlet } from "react-router-dom";

function StaffLayout() {
  return (
    <div style={{ minHeight: "100vh", background: "#f8fafc" }}>
      <NavbarStaff />
      <Outlet />
    </div>
  );
}

export default StaffLayout;